import axios from "axios";

console.log("backend: ", "powerautomate");

const api = axios.create({
  baseURL: "https://default45601a2c65c944efa9870f1f7edc66.25.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/3a4dc0d415304da7ae8451297309fa53/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LhK3ITI5TAaRep_IRK61z00Rm6AnpYH1wKIcFGYQ-Vo",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "01948902-0e32-7a95-a9c6-d80228a938fd",
  },
});

export default api;
